import React from 'react';
import useTailwindBrand from '../../Theme/useTailwindBrand';

interface FormSectionProps {
    title: string;
    children: React.ReactNode;
    className?: string;
}

const FormSection: React.FC<FormSectionProps> = ({
    title,
    children,
    className = ''
}) => {
    const { classes, common } = useTailwindBrand();

    return (
        <div className={`space-y-6 ${className}`}>
            <div className="border-b border-gray-200 pb-2">
                <h3 className={`${classes.primaryText} ${classes.fontFamily} ${common.subtitle3} font-semibold`}>
                    {title}
                </h3>
            </div>
            {children}
        </div>
    );
};

export default FormSection;
